const Loader = ({ loading }) => {
  return (
    <div
      id="modelConfirm"
      className="fixed  z-50 inset-0 bg-gray-900 bg-opacity-60 overflow-y-auto h-full w-full px-4 "
    >
      <div
        className="border-gray-300 h-14 w-14 animate-spin 
        flex justify-center items-center m-auto rounded-full border-2 border-t-primary
        fixed md:top-[50%] md:left-[50%] top-[40%] left-[40%]
       "
       
      />
    </div>
  );
};

export default Loader;
